import logoFullDay from "../assets/images/logoFull-BW.png";
import logoFullNight from "../assets/images/logoFull-BW-NM.png";
import logoMobileDay from "../assets/images/logoMobile-BW.png";
import logoMobileNight from "../assets/images/logoMobile-BW-NM.png";
import authPageImageDay from "../assets/images/bottom-image.png";
import authPageImageNight from "../assets/images/bottom-image-NM.png";
import noDataDay from "../assets/images/no-data.svg";
import noDataNight from "../assets/images/no-data-nm.svg";
import { useAppContext } from "../Components/Context/AppContext";

const themedAssets = {
  logoFull: { day: logoFullDay, night: logoFullNight },
  logoMobile: { day: logoMobileDay, night: logoMobileNight },
  authPageImage: { day: authPageImageDay, night: authPageImageNight },
  noData: { day: noDataDay, night: noDataNight },
};

export function getThemedAsset(assetKey, theme = "day") {
  const assets = themedAssets[assetKey];
  if (!assets) {
    return null;
  }
  return theme === "night" ? assets.night : assets.day;
}

export function useThemedAssets() {
  const { theme } = useAppContext();

  return {
    logoFull: getThemedAsset("logoFull", theme),
    logoMobile: getThemedAsset("logoMobile", theme),
    authPageImage: getThemedAsset("authPageImage", theme),
    noData: getThemedAsset("noData", theme),
  };
}
